<template>
  <div class="max-w-screen custom-bg-color relative flex items-center justify-center md:max-h-screen">
    <jet-authentication-card
      class="z-10"
      sm:extraClassesName="max-width: 343px !important"
      sm2:extraClassesName="max-width:500px !important"
    >
      <template #logo>
        <!-- <jet-authentication-card-logo class="w-full" /> -->
        <img
          :src="cdn('images/instawp-gradient-logo.svg')"
          class="cursor-pointer lg:hidden"
          alt=""
          srcset=""
        >
      </template>

      <jet-validation-errors class="mb-4" />

      <div
        v-if="status"
        class="mb-4 text-sm font-medium text-green-600"
      >
        {{ status }}
      </div>

      <div class="w-full sm2:w-96">
        <div>
          <h3 class="sign-in-line relative text-lg font-bold capitalize text-grayCust-1500 sm2:text-3xl">
            {{ $t('sign_in') }}
          </h3>
          <div class="mb-4 mt-2 h-px w-14 bg-grayCust-1500 sm2:h-0.5 sm2:w-24 md:mb-8 md:mt-6" />
        </div>

        <div>
          <jet-label
            for="email"
            class="text-grayCust-1500"
            :value="$t('email_address')"
          />
          <jet-input
            id="email"
            v-model="form.email"
            name="email"
            type="email"
            class="form-email-text mt-1 block w-full"
            required
            autofocus
          />
        </div>

        <div class="mt-5 md:mt-8">
          <jet-label
            for="password"
            class="text-grayCust-1500"
            :value="$t('password')"
          />
          <jet-input
            id="password"
            v-model="form.password"
            name="password"
            type="password"
            class="form-email-text mt-1 block w-full"
            required
            autocomplete="current-password"
          />
        </div>

        <div class="mt-4 flex justify-between md:mt-8">
          <label class="flex items-center">
            <jet-checkbox
              v-model="form.remember"
              name="remember"
            />
            <span class="ml-2 text-base text-grayCust-1500 md:ml-3">{{ $t('remember_me') }}</span>
          </label>
          <inertia-link
            href="/forgot-password"
            class="text-base font-medium text-grayCust-1500"
          >
            {{ $t('forgot_password') }}?
          </inertia-link>
        </div>

        <div class="mt-4 md:mt-8">
          <!-- <inertia-link class=" text-sm text-gray-600 hover:text-gray-900" href="/register">
                        Register
                    </inertia-link> -->
          <jet-button
            class=" font-sign flex h-12 w-full justify-center bg-primary-900 py-3 font-semibold normal-case hover:bg-primary-700"
            @click="login"
          >
            {{ $t('sign_in') }} 
          </jet-button>
        </div>

        <div class="mt-5 flex items-center justify-center md:mt-8">
          <p class="text-base text-grayCust-1500">
            {{ $t('you_have_not_any_account') }}?
          </p>
          <inertia-link
            class=" ml-1 text-base font-bold text-primary-900 hover:text-primary-700"
            href="/register"
          >
            {{ $t('sign_up') }} 
          </inertia-link>
        </div>

        <div class="mt-5 flex items-center justify-center md:mt-8">
          <span
            class="w-20 border-b "
          /> <a
            href="#"
            class="mx-1.5 text-center text-xs text-grayCust-370 hover:underline"
          >{{ $t('continue_with') }}</a> <span class="w-20 border-b " />
        </div>

        <Social-media-login />
      </div>
    </jet-authentication-card>
  </div>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import SocialMediaLogin from '@/components/UpdatedDesignVersion/Authentication/SocialMediaLogin.vue'

import { useAppStore } from '@/store/index'
import { mapStores } from 'pinia'

export default {
    
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        SocialMediaLogin
    },

    props: {
        canResetPassword: Boolean,
        status: String,       
        useremail:{
            type:String,
            default:''
        }
    },
    computed: {
        ...mapStores(useAppStore),
    },    
    methods:{
        login() {
          const that = this;
          axios
          .post(route('login'), that.form)
          .then((response) => {
              that.appStore.user = response.data.data;
              that.userId = response.data.data.id;
              that.close();
          })
          .catch((error) => {
          })
        },
        close() {
          this.$emit('close', this.userId);
        }
    },

    data() {
        return {
          form: {
            _token: document.querySelector('meta[name="csrf-token"]').content,
            email:this.useremail,
            password:'',
            isModalLogin: true
          },
          userId: null
        }
    }
}
</script>
<style scoped>
.custom-bg-color{
    background: linear-gradient(248.22deg, #1E8075 -2.64%, #00473F 93.03%);
}
.form-email-text:focus{
    outline: none;
    box-shadow: none;
    border: 1px solid #1E8075 ;
}
.font-sign{
    font-size: 16px !important;
}
</style>